import { Component, OnInit, Input } from '@angular/core';
import { SectionCertificationContainerService } from './section-certification-container.service';
import { Certification } from '@fcp/lib-ui';

@Component({
  selector: 'fcp-section-certification-container',
  template: `
    <fcp-section-certification
      [certification]="certification"
    ></fcp-section-certification>
  `
})
export class SectionCertificationContainerComponent implements OnInit {
  @Input() public data: Certification;
  public certification: Certification;
  constructor(
    private sectionCertificationContainerService: SectionCertificationContainerService
  ) {}

  ngOnInit() {
    this.certification = this.sectionCertificationContainerService.mapCertificationsData(
      this.data
    );
  }
}
